import { convertLanguageToKey } from 'shared-utils';
import { getNavigationLabels } from './requests';
import { useQuery } from '@tanstack/react-query';
import { useAppContext } from '@common/contexts/AppContext';

export const labelKeys = {
  labels: (siteSlug: string) => ['labels', siteSlug] as const,
};

export async function fetchNavigationLabels({ siteSlug }: { siteSlug: string }): Promise<{
  [languageKey: string]: { [key: string]: string };
}> {
  try {
    const { thesauruses = [] } = await getNavigationLabels({ siteSlug });
    const navigationLabels = thesauruses.reduce((acc, language) => {
      acc[convertLanguageToKey(language.language)] = { ...language.terms };
      return acc;
    }, {});
    return navigationLabels;
  } catch (_) {}
  return {};
}

export function useNavigationLabels() {
  const { siteSlug } = useAppContext();

  return useQuery({
    queryKey: labelKeys.labels(siteSlug),
    queryFn: () => fetchNavigationLabels({ siteSlug }),
  });
}
